export default __webpack_public_path__ + "static/headstand-onelegup-2-ce601b9820eaf7f482f716e66e42da00.jpg";